"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCommentConnuConsultimCorporationTrads = void 0;
exports.ESubCommentConnuConsultimCorporationTrads = {
    autre: "Autre",
    connseillerFinancier: "Conseiller Financier ou Gestion de patrimoine",
    email: "Email",
    internet: "Internet",
    presse: "Article de presse",
    publicitePresse: "Publicité presse",
    recommandation: "Recommandation (ami, famille, collègue)",
};
